import React from "react";
import styles from "./TravelCancellationSection.module.css";
import travelimgs from "../../../Images/TravelCancellation_img.png";

const TravelCancellationSection = () => {

    return (
        <section className={styles.section}>
            <h2 className={styles.heading}>
                Seamless Bookings & Cancellations
            </h2>
            <p>
                Automate reservations across hotels, flights, and tours with instant <br />
                confirmations and easy modifications
            </p>
            <div className={styles.wrapper}>
                <div className={styles.featureList}>
                    <div className={styles.item}>
                        <span className={styles.dot}></span>
                        <div>
                            <h4>Real-time booking updates</h4>
                        </div>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.dot}></span>
                        <div>
                            <h4>Automated cancellations and refunds</h4>
                        </div>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.dot}></span>
                        <div>
                            <h4>Multi-platform integration</h4>
                        </div>
                    </div>
                    <div className={styles.buttons}>
                        <button className={styles.primaryBtn} >Automate Bookings</button>
                    </div>
                </div>

                {/* RIGHT IMAGE */}
                <div className={styles.right}>
                    <img src={travelimgs} alt="travel cancellation" />
                </div>
            </div>
        </section>
    );
};

export default TravelCancellationSection;
